import { Link } from "react-router-dom";
import { brandConfig } from "../../../config/brand";
import { siteConfig } from "../../../config/site";

export function PublicFooter() {
  return (
    <footer className="border-t border-white/10 bg-slate-950/45">
      <div className="mx-auto grid w-full max-w-6xl gap-8 px-4 py-10 text-sm text-slate-400 sm:px-6 lg:grid-cols-[1.2fr_0.8fr]">
        <div>
          <Link to="/" className="inline-flex items-center gap-3 text-white" aria-label="Αρχική Brain Test">
            <img src={brandConfig.logoMarkPath} alt="" className="h-9 w-9 object-contain" />
            <span className="font-bold">{brandConfig.brandName}</span>
          </Link>
          <p className="mt-4 max-w-md">Premium IQ-style logic challenge για μοτίβα, λογική και ταχύτητα σκέψης.</p>
          <p className="mt-3">
            Υποστήριξη:{" "}
            <a className="text-cyan-100 hover:text-white" href={`mailto:${brandConfig.supportEmail}`}>
              {brandConfig.supportEmail}
            </a>
          </p>
          <p className="mt-5 text-xs">© {new Date().getFullYear()} {brandConfig.brandName}. Με επιφύλαξη παντός δικαιώματος.</p>
        </div>
        <nav className="grid gap-3 sm:grid-cols-2" aria-label="Σύνδεσμοι footer">
          {siteConfig.footerLinks.map((link) => (
            <Link key={link.href} to={link.href} className="rounded-lg py-1 transition hover:text-white">
              {link.label}
            </Link>
          ))}
        </nav>
      </div>
    </footer>
  );
}
